import classNames from 'classnames';
import { useMemo, useState } from 'react';
import CustomerSearch, { SelectCustomerType } from './CustomerSearch';
import { CustomerSearchProvider } from './context/CustomerSearchProvider';
import { SearchParams } from './components/CustomerSearchBox/CustomerSearchBox';
interface MultiTenantCustomerSearchProps {
  onSelectCustomer: (
    customerId: string,
    customerName: string,
    tenantId: string,
  ) => void;
  show?: boolean;
}

const MultiTenantCustomerSearch = ({
  onSelectCustomer,
  show = false,
}: MultiTenantCustomerSearchProps) => {
  const [searchParams, setSearchParams] = useState<SearchParams>({
    name: '',
    phone: '',
    street: '',
    unit: '',
    zip: '',
  });

  const handleSelectCustomer = (customer?: SelectCustomerType) => {
    if (!customer) {
      return;
    }
    if (customer.id && customer.name && customer.tenant?.id) {
      onSelectCustomer(customer.id, customer.name, customer.tenant.id);
    }
  };

  const contextValue = useMemo(() => {
    return { searchParams, setSearchParams };
  }, [searchParams, setSearchParams]);

  return (
    <CustomerSearchProvider {...contextValue}>
      <div className={classNames('w-100', { 'd-n': !show })}>
        <CustomerSearch onSelectCustomer={handleSelectCustomer} />
      </div>
    </CustomerSearchProvider>
  );
};

export default MultiTenantCustomerSearch;
